import { useState } from 'react';
import { Search, Calendar, Users, ArrowRightLeft, PlaneTakeoff, PlaneLanding, ChevronDown } from 'lucide-react';
import { useEffect } from 'react';

const Type4SearchForm = (props) => {

    const {
        searchOnSubmit,
        agentDetails,
        bookingEngine,
        sp_remove_traveler,
        sp_add_traveler,
        sp_select_cabin_type,
        sp_select_trip_round,
        sp_show_cabin_settings_pane,
        sp_show_travelers_settings_pane,
        sp_show_trip_round_settings_pane,
        sp_open_from_where_auto_complete_pane,
        sp_switch_airports_input_values,
        sp_open_to_where_auto_complete_pane
    } = props;

    // Search Form State
    const [tripType, setTripType] = useState('oneway');
    const [origin, setOrigin] = useState('New York (JFK)');
    const [destination, setDestination] = useState('London (LHR)');
    const [departureDate, setDepartureDate] = useState('2025-12-29');
    const [returnDate, setReturnDate] = useState('2026-01-05');
    const [travelers, setTravelers] = useState(1);
    const [cabinClass, setCabinClass] = useState('Economy');
    
    window.__setTravelers = setTravelers;
    window.__setTripType = setTripType;
    window.__setCabinClass = setCabinClass;

    const styles = {
        container: {
          backgroundColor: '#f8fafc',
          fontFamily: "'Inter', sans-serif",
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        },
        header: {
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #e2e8f0',
          position: 'sticky',
          top: 0,
          zIndex: 100,
        },
        logoText: {
          background: 'linear-gradient(to right, #4f46e5, #7c3aed)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontWeight: 800,
          fontSize: '1.25rem',
        },
        searchHero: {
          background: '#ffffff',
          borderBottom: '1px solid #e2e8f0',
          padding: '2rem 0 3rem 0',
          position: 'relative',
        },
        formCard: {
          backgroundColor: '#ffffff',
          borderRadius: '1.5rem',
          padding: '1.5rem',
          /*boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.03)',*/
          border: '1px solid #f1f5f9',
          marginTop: -10,
          marginBottom: 20,
        },
        inputGroup: {
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          flex: 1,
          minWidth: '200px',
        },
        inputLabel: {
          fontSize: '0.65rem',
          fontWeight: 800,
          color: '#64748b',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          marginLeft: '0.25rem',
        },
        inputWrapper: {
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.75rem 1rem',
          backgroundColor: '#f8fafc',
          borderRadius: '0.85rem',
          border: '1px solid #e2e8f0',
          transition: 'all 0.2s ease',
        },
        searchButton: {
          backgroundColor: (bookingEngine?.actionButtonsBg || '#4f46e5'),
          color: (bookingEngine?.actionButtonsTxtColor || '#ffffff'),
          padding: '1rem 2.5rem',
          borderRadius: (bookingEngine?.searchButtonBorderRadius || '1rem'),
          fontWeight: 800,
          fontSize: '0.875rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: "center",
          gap: '0.75rem',
          transition: 'all 0.2s ease',
          border: 'none',
          cursor: 'pointer',
          boxShadow: ('0 10px 15px -3px' +((bookingEngine?.actionButtonsBg+"40") || 'rgba(79, 70, 229, 0.3)')),
          alignSelf: 'flex-end',
          height: '3.25rem',
        },
        tabButton: (active) => ({
          padding: '0.5rem 1rem',
          fontSize: '0.75rem',
          fontWeight: 700,
          borderRadius: '0.5rem',
          transition: 'all 0.2s ease',
          cursor: 'pointer',
          border: active ? ('1px solid '+((bookingEngine?.actionButtonsBg+"1A") || '#e0e7ff')) : '1px solid transparent',
          backgroundColor: active ? ((bookingEngine?.actionButtonsBg+"1A") || '#eef2ff') : 'transparent',
          color: active ? (bookingEngine?.actionButtonsBg || '#4f46e5') : '#64748b',
        })
    };
    
    return <div className="margin_horizontal_10_px_at_1000vw" style={styles.formCard}>
        {/* Trip Options Bar */}
        <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
            <div className="flex bg-slate-50 p-1 rounded-lg border border-slate-100">
                <button 
                    onClick={() =>sp_select_trip_round("round-trip")}
                    style={styles.tabButton(tripType === 'round')}>
                    Round Trip
                </button>
                <button 
                    onClick={()=>sp_select_trip_round("one-way")}
                    style={styles.tabButton(tripType === 'oneway')}>
                    One Way
                </button>
            </div>
            
            <div style={{position: "relative"}} className="flex items-center gap-6">
                <div onClick={sp_show_travelers_settings_pane} className="flex items-center gap-2 cursor-pointer group">
                    <Users style={{ width: "16px", height: "16px", color: (bookingEngine?.actionButtonsBg)}} className="text-indigo-600" />
                    <span className="text-xs font-bold text-slate-700 group-hover:text-indigo-600 transition-colors">
                        {travelers} Traveler{travelers > 1 ? 's' : ''}
                    </span>
                    <ChevronDown style={{ width: "16px", height: "16px" }} className="text-slate-400" />
                </div>
                <div onClick={sp_show_cabin_settings_pane} className="flex items-center gap-2 cursor-pointer group">
                    <div style={{backgroundColor: (bookingEngine?.actionButtonsBg)}} className="w-1.5 h-1.5 rounded-full bg-indigo-600"></div>
                    <span className="text-xs font-bold text-slate-700 group-hover:text-indigo-600 transition-colors">
                        {cabinClass}</span>
                    <ChevronDown style={{ width: "16px", height: "16px" }} className="text-slate-400" />
                </div>
                <div id="sp_forms_main_class_guests_cabin_settings_pane" style={{zIndex: 1002, minWidth: 350, right: 0, left: "auto"}} className="forms_class_guests_cabin_settings_pane">
                    <p onClick={() => {
                            if(document.getElementById("sp_forms_main_class_guests_cabin_settings_pane"))
                                document.getElementById("sp_forms_main_class_guests_cabin_settings_pane").style.display = "none"
                        }
                    } className="airports_auto_complete_close_btn">&times;</p>
                    <div id="sp_add_travelers_settings_pane" style={{padding: 15, display: "none"}}>
                        <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", fontWeight: "bolder", fontSize: 17, marginTop: 10, marginBottom: 20}}>
                            Add Travelers</p>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Adults
                                <p style={{fontSize: 12, color: "rgba(0,0,0,0.6)"}}>18 and above</p>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                                <div onClick={()=>sp_remove_traveler("adult")} style={{cursor: "pointer", borderRadius: "100%", border: "1px solid rgba(0,0,0,0.3)", width: 35, height: 35, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    -</div>
                                <div id="sp_add_travelers_display_adults_number" style={{color: "rgba(0,0,0,0.7)", width: 40, height: 30, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    1</div>
                                <div onClick={()=>sp_add_traveler("adult")} style={{cursor: "pointer", borderRadius: "100%", border: "1px solid rgba(0,0,0,0.3)", width: 35, height: 35, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    +</div>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Children
                                <p style={{fontSize: 12, color: "rgba(0,0,0,0.6)"}}>Ages 2 to 17</p>
                                </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                                <div onClick={()=>sp_remove_traveler("child")} style={{cursor: "pointer", borderRadius: "100%", border: "1px solid rgba(0,0,0,0.3)", width: 35, height: 35, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    -</div>
                                <div id="sp_add_travelers_display_children_number" style={{color: "rgba(0,0,0,0.7)", width: 40, height: 30, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    0</div>
                                <div onClick={()=>sp_add_traveler("child")} style={{cursor: "pointer", borderRadius: "100%", border: "1px solid rgba(0,0,0,0.3)", width: 35, height: 35, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    +</div>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Infants
                                <p style={{fontSize: 12, color: "rgba(0,0,0,0.6)"}}>Younger than 2</p>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                                <div onClick={()=>sp_remove_traveler("infant")} style={{cursor: "pointer", borderRadius: "100%", border: "1px solid rgba(0,0,0,0.3)", width: 35, height: 35, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    -</div>
                                <div id="sp_add_travelers_display_infants_number" style={{color: "rgba(0,0,0,0.7)", width: 40, height: 30, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    0</div>
                                <div onClick={()=>sp_add_traveler("infant")} style={{cursor: "pointer", borderRadius: "100%", border: "1px solid rgba(0,0,0,0.3)", width: 35, height: 35, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    +</div>
                            </div>
                        </div>
                    </div>
                    <div id="sp_select_cabin_settings_pane" style={{padding: 15, display: "none"}}>
                        <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", fontWeight: "bolder", marginTop: 10, marginBottom: 20}}>
                            Select Cabin</p>
                        <div onClick={()=>{}/*sp_select_cabin_type("cheapest")*/} style={{display: "flex", display: "none", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <label htmlFor="sp_select_cabin_cheapest_chk"><div style={{cursor: "not-allowed", color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Cheapest</div></label>
                            <div style={{height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                <input id="sp_select_cabin_cheapest_chk" disabled={true} className="sp_select_cabin_type_chk" style={{width: 20, height: 20}} type="radio" defaultChecked={false}/>
                            </div>
                        </div>
                        <div onClick={()=>sp_select_cabin_type("economy")} style={{cursor: "pointer", display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <label htmlFor="sp_select_cabin_economy_chk"><div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Economy</div></label>
                            <div style={{height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                <input id="sp_select_cabin_economy_chk" className="sp_select_cabin_type_chk" style={{width: 20, height: 20}} type="radio" />
                            </div>
                        </div>
                        <div onClick={()=>sp_select_cabin_type("premium")} style={{cursor: "pointer", display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <label htmlFor="sp_select_cabin_premium_chk"><div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Premium</div></label>
                            <div style={{height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                <input id="sp_select_cabin_premium_chk" className="sp_select_cabin_type_chk" style={{width: 20, height: 20}} type="radio" />
                            </div>
                        </div>
                        <div onClick={()=>sp_select_cabin_type("business")} style={{cursor: "pointer", display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <label htmlFor="sp_select_cabin_business_chk"><div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Business</div></label>
                            <div style={{height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                <input id="sp_select_cabin_business_chk" className="sp_select_cabin_type_chk" style={{width: 20, height: 20}} type="radio" />
                            </div>
                        </div>
                        <div onClick={()=>sp_select_cabin_type("first")} style={{cursor: "pointer", display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <label htmlFor="sp_select_cabin_first_chk"><div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                First</div></label>
                            <div style={{height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                <input id="sp_select_cabin_first_chk" className="sp_select_cabin_type_chk" style={{width: 20, height: 20}} type="radio" />
                            </div>
                        </div>
                    </div>
                    <div id="sp_select_trip_round_settings_pane" style={{padding: 15, display: "none"}}>
                        <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", fontWeight: "bolder", marginTop: 10, marginBottom: 20}}>
                            Select Trip Round</p>
                        <div onClick={()=>sp_select_trip_round("round-trip")} style={{cursor: "pointer", display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <label htmlFor="sp_trip_round_round_trip_chk"><div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Round-trip</div></label>
                            <div style={{height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                <input id="sp_trip_round_round_trip_chk" className="sp_select_trip_round_chk" style={{width: 20, height: 20}} type="radio" />
                            </div>
                        </div>
                        <div onClick={()=>sp_select_trip_round("one-way")} style={{cursor: "pointer", display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <label htmlFor="sp_trip_round_one_way_chk"><div style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                One-way</div></label>
                            <div style={{height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                <input id="sp_trip_round_one_way_chk" className="sp_select_trip_round_chk" style={{width: 20, height: 20}} type="radio" defaultChecked />
                            </div>
                        </div>
                        <div onClick={()=>{}/*()=>sp_select_trip_round("multi-city")*/} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10}}>
                            <label htmlFor="sp_trip_round_multi_city_chk"><div style={{cursor: "not-allowed", color: "rgba(0,0,0,0.2)", fontFamily: "'Prompt', sans-serif", height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                Multi-city</div></label>
                            <div style={{height: 30, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                <input id="sp_trip_round_multi_city_chk" className="sp_select_trip_round_chk" disabled={true} style={{width: 20, height: 20}} type="radio" />
                            </div>
                        </div>
                    </div>
                    <div onClick={()=> {
                            if(document.getElementById("sp_forms_main_class_guests_cabin_settings_pane"))
                                document.getElementById("sp_forms_main_class_guests_cabin_settings_pane").style.display = "none"
                        }
                    } style={{cursor: "pointer", padding: 10, margin: 10, marginTop: 0, 
                        backgroundColor: bookingEngine?.actionButtonsBg, 
                        color: bookingEngine?.actionButtonsTxtColor, textAlign: "center", 
                        borderRadius: bookingEngine?.actionButtonBorderRadius, textAlign: "center"}}>
                        Done
                    </div>
                </div>
            </div>
        </div>

        {/* Main Input Row */}
        <div style={{position: "relative"}} className="flex flex-col xl:flex-row gap-4 items-stretch">
            <div className="flex-1 flex flex-col md:flex-row gap-2">
                {/* Origin */}
                <div style={{...styles.inputGroup, minWidth: 300}}>
                    <div id="sp_from_where_airports_auto_complete_input" className="airports_inputs_with_auto_complete" style={{zIndex: 10}}>
                        <p onClick={() => {
                                if(document.getElementById("sp_from_where_airports_auto_complete_input"))
                                    document.getElementById("sp_from_where_airports_auto_complete_input").style.display = "none"
                            }
                        } className="airports_auto_complete_close_btn">&times;</p>
                        <input autoComplete="off" id="sp_from_where_airports_auto_complete_input_fld" 
                            onBlur={() => {
                                setTimeout(() => {
                                    if(document.getElementById("sp_from_where_airports_auto_complete_input"))
                                        document.getElementById("sp_from_where_airports_auto_complete_input").style.display = "none";
                                }, 500);
                            }} className="airports_auto_complete_input" type="text" placeholder="Where are you leaving from?"/>
                        <div className="airports_auto_complete_list_container">
                            <ul id="sp_flights_auto_complete_from_where_input_list">
                                <li><div style={{padding: 10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
                                    <div style={{height: 35, marginRight: 10, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                        <i className="fa fa-history" style={{color: "rgba(0,0,0,0.3)", fontSize: 17}}></i>
                                    </div>
                                    <div>
                                        <div>
                                            <p style={{fontSize: 14, fontWeight: "bolder", color: "rgba(0,0,0,0.8)"}}>
                                                New York (LGA - Laguardia)
                                            </p>
                                            <p style={{fontSize: 14, color: "rgba(0,0,0,0.8)"}}>
                                                United States
                                            </p>
                                        </div>
                                    </div>
                                </div></li>
                            </ul>
                        </div>
                    </div>
                    <label style={styles.inputLabel}>From</label>
                    <div style={styles.inputWrapper} className="hover:border-indigo-200 hover:bg-white focus-within:border-indigo-400 focus-within:bg-white focus-within:ring-2 focus-within:ring-indigo-100">
                        <PlaneTakeoff style={{ width: "24px", height: "24px" }} className="text-slate-400" />
                        <input id="sp_search_forms_from_where_input_fld"
                             onClick={sp_open_from_where_auto_complete_pane}
                            type="text" 
                            readOnly={true}
                            placeholder="Departure Airport"
                            className="bg-transparent border-none outline-none text-sm font-bold text-slate-900 w-full placeholder:text-slate-300"
                        />{/*value={origin}
                            onChange={(e) => setOrigin(e.target.value)}*/}
                    </div>
                </div>

                {/* Switch Button (Desktop Only) */}
                <div className="hidden md:flex items-center justify-center pt-5">
                    <div className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-indigo-600 cursor-pointer hover:shadow-md hover:scale-110 transition-all z-10 -mx-4 shadow-sm">
                        <i className='fa-solid fa-exchange'  style={{ fontSize: 15, color: (bookingEngine?.actionButtonsBg)}} ></i>
                    </div>
                </div>

                {/* Destination */}
                <div style={{...styles.inputGroup, minWidth: 300}}>
                    <div id="sp_to_where_airports_auto_complete_input" className="airports_inputs_with_auto_complete" style={{zIndex: 10}}>
                        <p onClick={() => {
                                if(document.getElementById("sp_to_where_airports_auto_complete_input"))
                                    document.getElementById("sp_to_where_airports_auto_complete_input").style.display = "none"
                            }
                        } className="airports_auto_complete_close_btn">&times;</p>
                        <input autoComplete="off" id="sp_to_where_airports_auto_complete_input_fld" 
                            onBlur={()=>{
                                setTimeout(() => {
                                    if(document.getElementById("sp_to_where_airports_auto_complete_input"))
                                        document.getElementById("sp_to_where_airports_auto_complete_input").style.display = "none";
                                }, 500);
                            }} className="airports_auto_complete_input" type="text" placeholder="Where are you going to?"/>
                        <div className="airports_auto_complete_list_container">
                            <ul id="sp_flights_auto_complete_to_where_input_list">
                                <li><div style={{padding: 10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
                                    <div style={{height: 35, marginRight: 10, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                        <i className="fa fa-history" style={{color: "rgba(0,0,0,0.3)", fontSize: 17}}></i>
                                    </div>
                                    <div>
                                        <div>
                                            <p style={{fontSize: 14, fontWeight: "bolder", color: "rgba(0,0,0,0.8)"}}>
                                                New York (LGA - Laguardia)
                                            </p>
                                            <p style={{fontSize: 14, color: "rgba(0,0,0,0.8)"}}>
                                                United States
                                            </p>
                                        </div>
                                    </div>
                                </div></li>
                            </ul>
                        </div>
                    </div>
                    <label style={styles.inputLabel}>To</label>
                    <div style={styles.inputWrapper} className="hover:border-indigo-200 hover:bg-white focus-within:border-indigo-400 focus-within:bg-white focus-within:ring-2 focus-within:ring-indigo-100">
                        <PlaneLanding style={{ width: "24px", height: "24px" }} className="text-slate-400" />
                        <input id="sp_search_forms_to_where_input_fld"
                            onClick={sp_open_to_where_auto_complete_pane}
                            type="text" 
                            readOnly={true}
                            placeholder="Destination Airport"
                            className="bg-transparent border-none outline-none text-sm font-bold text-slate-900 w-full placeholder:text-slate-300"
                        />{/*value={destination}
                            onChange={(e) => setDestination(e.target.value)}*/}
                    </div>
                </div>
            </div>

            <div className="flex-1 flex flex-col md:flex-row gap-2">
                {/* Departure Date */}
                <div style={styles.inputGroup}>
                    <label style={styles.inputLabel}>Travel Dates:</label>
                    <div style={styles.inputWrapper} className="hover:border-indigo-200 hover:bg-white focus-within:border-indigo-400 focus-within:bg-white">
                        <Calendar style={{ width: "24px", height: "24px" }} className="text-slate-400" />
                        <input id="sp_departure_return_dates_input"
                            type="text" 
                            readOnly={true}
                            className="bg-transparent border-none outline-none text-sm font-bold text-slate-900 w-full"
                        />{/*value={departureDate}
                            onChange={(e) => setDepartureDate(e.target.value)}*/}
                    </div>
                </div>

                {/* Return Date (Optional) */}
                {/*<div style={{...styles.inputGroup, opacity: tripType === 'oneway' ? 0.5 : 1}}>
                    <label style={styles.inputLabel}>Return</label>
                    <div style={styles.inputWrapper} className="hover:border-indigo-200 hover:bg-white focus-within:border-indigo-400 focus-within:bg-white">
                        <Calendar style={{ width: "24px", height: "24px" }} className="text-slate-400" />
                        <input 
                            type="date" 
                            value={returnDate}
                            disabled={tripType === 'oneway'}
                            onChange={(e) => setReturnDate(e.target.value)}
                            className="bg-transparent border-none outline-none text-sm font-bold text-slate-900 w-full"
                        />
                    </div>
                </div>*/}
            </div>

            {/* Hidden Form Elements */}
            <div id="sp_select_cabin_type_main_input_display" onClick={sp_show_cabin_settings_pane} style={{display: "none", cursor: "pointer", fontFamily: "'Prompt', sans-serif", marginRight: 30, fontSize: 14}}>
                <i style={{fontSize: 15, marginRight: 10}} className="fa fa-level-up"></i>
                Cheapest
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
            </div>
            <div id="sp_add_travelers_main_input_display" onClick={sp_show_travelers_settings_pane} style={{display: "none", cursor: "pointer", fontFamily: "'Prompt', sans-serif", marginRight: 30, fontSize: 14}}>
                <i style={{fontSize: 15, marginRight: 10}} className="fa fa-user"></i>
                1 Adult
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
            </div>
            <div id="sp_select_trip_round_main_input_display" onClick={sp_show_trip_round_settings_pane} style={{display: "none", cursor: "pointer", fontFamily: "'Prompt', sans-serif", marginRight: 30, fontSize: 14}}>
                <i style={{fontSize: 15, marginRight: 10}} className="fa fa-repeat"></i>
                One-way
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
            </div>
            <input id="sp_trip_round_one_way_chk" className="sp_select_trip_round_chk" style={{display: "none", width: 20, height: 20}} type="radio" defaultChecked />
                                

            {/* Search CTA */}
            <button onClick={searchOnSubmit}
                style={styles.searchButton}
                className="hover:bg-indigo-700 hover:scale-[1.02] active:scale-95 transition-all w-full xl:w-auto mt-4 xl:mt-0">
                <i className='fa-solid fa-search' style={{ fontSize: 16, color: bookingEngine?.actionButtonsIconColor }}></i>
                Search Flights
            </button>
        </div>
    </div>;

}

export default Type4SearchForm;